import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { SCHRIFTZUG } from "@/lib/media";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const { t } = useLang();
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/admin/dashboard", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err) || t("admin_login_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-5">
      <div className="max-w-sm w-full border border-white/10 bg-hell-coal p-10">
        <img src={SCHRIFTZUG} alt="Krampus Show" className="h-10 w-auto mx-auto mb-6" />
        <h1 className="font-display text-2xl text-hell-bone text-center mb-2">{t("admin_login_t")}</h1>
        <p className="text-hell-smoke text-sm text-center mb-8">{t("admin_login_d")}</p>
        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-4">
          <Input data-testid="admin-email" type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="E-Mail"
            className="bg-white/5 border-white/15 text-hell-bone placeholder:text-hell-bone/40 h-12" />
          <Input data-testid="admin-password" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)} placeholder="Passwort"
            className="bg-white/5 border-white/15 text-hell-bone placeholder:text-hell-bone/40 h-12" />
          {error && <p data-testid="admin-login-error" className="text-hell-redhot text-sm">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full rounded-full bg-hell-red hover:bg-hell-redhot text-hell-bone font-cinzel tracking-[0.15em] uppercase text-xs h-12">
            <Flame className="w-4 h-4 mr-2" />{loading ? "…" : t("admin_login_cta")}
          </Button>
        </form>
      </div>
    </main>
  );
}
